import { caseComponents } from "./components/caseData";
import { gpuComponents } from "./components/gpuData";
import { motherboardComponents } from "./components/motherboardData";
import { osComponents, additionalComponents } from "./components/osData";
import { psuComponents } from "./components/psuData";
import { ramComponents } from "./components/ramData";
import { storageComponents } from "./components/storageData";
import { coolerComponents } from "./components/coolerData";
import { fanComponents } from "./components/fanData";
import { accessoriesComponents } from "./components/accessoriesData";
import { ComponentCategory, PcConfiguration } from "@/types/types";

export const mockComponents: ComponentCategory[] = [
  caseComponents,
  {
    id: "cpu",
    name: "Processor (CPU)",
    description: "The brain of your PC that handles all the instructions and calculations.",
    required: true,
    options: [], // options will be loaded from Supabase in the UI
  },
  motherboardComponents,
  gpuComponents,
  ramComponents,
  storageComponents,
  coolerComponents,
  psuComponents,
  osComponents,
  additionalComponents,
  fanComponents,
  accessoriesComponents,
];

export const calculateTotalPrice = (configuration: PcConfiguration): number => {
  let totalPrice = 0;

  // Process all single components first
  for (const categoryId of Object.keys(configuration)) {
    if (categoryId === 'accessories' || categoryId === 'fans') {
      continue; // Skip accessories and fans for now
    }
    const component = configuration[categoryId as keyof PcConfiguration];
    if (component && !Array.isArray(component) && 'price' in component) {
      totalPrice += (component as ComponentOption).price;
    }
  }

  // Process accessories
  if (configuration.accessories && Array.isArray(configuration.accessories)) {
    for (const accessory of configuration.accessories) {
      totalPrice += accessory.price;
    }
  }

  // Process fans
  if (configuration.fans) {
    const fanConfig = configuration.fans;
    if (fanConfig.quantity && fanConfig.quantity > 0) {
      totalPrice += fanConfig.price * fanConfig.quantity;
    }
  }

  // Add assembly fee
  totalPrice += 99;

  return totalPrice;
};
